import { SearchDashboard, AllPayTransactionRes } from '@/models/allpaytransactions.model'
import { VEClient } from '@/utils/axios'

export const postDashboard = async (data: SearchDashboard): Promise<AllPayTransactionRes> => {
	const response = await VEClient.post(`/api/allpay/dashboard`, data)
	return response.data
}